const BASE = process.env.REACT_APP_BACKEND_URL;
const j = async (r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); };

export const energyApi = {
  profile: (body) =>
    fetch(`${BASE}/api/energy/profile`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(j),

  climateNormals: (lat, lng) =>
    fetch(`${BASE}/api/energy/climate-normals?lat=${lat}&lng=${lng}`).then(j),

  exportUrl: `${BASE}/api/energy/profile/export`,

  exportXlsx: async (body) => {
    const r = await fetch(`${BASE}/api/energy/profile/export`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.blob();
  },

  importXlsx: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return fetch(`${BASE}/api/energy/profile/import`, { method: "POST", body: fd }).then(j);
  },
};
